<div [ngClass]="getClasses()" class="image-widget">
  <a *ngIf="widget.data.downloadOnClick; else imageTemplate" [target]="'_blank'" [download]="'test'" [href]="getImageFullUrl()">
    <ng-container *ngIf="false; else imageTemplate"></ng-container>
  </a>
</div>

<ng-template #imageTemplate>
  <app-webp-image [src]="getImageUrl()" [alt]="widget.data.altText" [title]="widget.data.tooltip ?? ''" [blurhash]="widget.data.blurHash ?? null"></app-webp-image>
</ng-template>
